import React from 'react';

import Skeleton from 'antd/lib/skeleton';

const Shimmer = () => (
    <Skeleton
        active
    />
);
export default Shimmer;
